import { RootState } from "../store";

const local = (state: RootState) => state.userReducer;

export const userSelector = (state: RootState) => local(state).user;
